import { inject, Pipe, PipeTransform } from '@angular/core';

import { MaskitoPipe } from '@maskito/angular';

import { isNumber } from 'lodash-es';

import { rateMask } from '../../constants/maskito.constants';
import { selectNonFloatNumberCharacters } from '../../constants/regular-expressions.constant';

type CurrencyInputType = string | number | undefined | null;

const defaultValue = 0;

@Pipe({
  name: 'redPercentage',
  standalone: false
})
export class PercentagePipe implements PipeTransform {
  private maskito = inject(MaskitoPipe);

  transform(value: CurrencyInputType, backupValue: string | number = defaultValue) {
    const number = parseFloat((value?.toString() || '').replace(selectNonFloatNumberCharacters, ''));
    let result = backupValue;

    if (isNaN(number) && isNumber(backupValue)) {
      result = this.maskito.transform(backupValue, rateMask);
    } else if (!isNaN(number)) {
      result = this.maskito.transform(number, rateMask);
    }

    return result;
  }
}
